/**
 * Product Calculator Controller v4
 * URL-Based Calculator Controller
 * Uses ?variant=variant_id URL parameter to determine calculator type
 */

document.addEventListener('DOMContentLoaded', function () {
  
  class ProductCalculatorController {
    constructor() {
      this.config = {
        defaultVariant: window.calculatorConfig?.defaultVariant || '',
        defaultVariantId: window.calculatorConfig?.defaultVariantId || '',
        currentSqft: parseFloat(window.calculatorConfig?.currentSqft) || 0
      };
      
      this.elements = {
        variantRadios: document.querySelectorAll("#variant-options input[type='radio']"),
        selectedProductId: document.querySelector('form[data-type="add-to-cart-form"] input[name="id"]')
      };

      this.initialize();
    }

    /**
     * Initialize the controller
     */
    initialize() {
      // Handle initial URL state
      this.handleUrlVariant();
      
      // Monitor URL changes (for GemPages navigation)
      this.monitorUrlChanges();
      
      // Initialize calculator display immediately since we already waited for instances
      this.updateCalculatorDisplay();
    }

    /**
     * Handle variant from URL parameter
     */
    handleUrlVariant() {
      const urlParams = new URLSearchParams(window.location.search);
      const variantIdFromUrl = urlParams.get('variant');
      
      if (variantIdFromUrl) {
        // Update variant selection based on URL
        this.updateVariantSelection(variantIdFromUrl);
      } else {
        // No variant in URL, use fullbox default
        this.setDefaultFullBoxVariant();
      }
    }

    /**
     * Update variant selection in hidden options
     */
    updateVariantSelection(variantId) {
      this.elements.variantRadios.forEach(radio => {
        if (radio.value === variantId) {
          radio.checked = true;
          
          // Update main product form if it exists
          if (this.elements.selectedProductId) {
            this.elements.selectedProductId.value = variantId;
          }
        } else {
          radio.checked = false;
        }
      });
      
      // Update variant attributes after selection changes
      this.updateVariantAttributes();
    }

    /**
     * Set default fullbox variant when no URL parameter
     */
    setDefaultFullBoxVariant() {
      // Find the first fullbox variant or use default
      let fullBoxVariant = null;
      
      this.elements.variantRadios.forEach(radio => {
        const title = radio.getAttribute('data-title') || '';
        if (title.toLowerCase().includes('box') && !fullBoxVariant) {
          fullBoxVariant = radio;
        }
      });
      
      // Use fullbox variant or fall back to default
      const targetVariant = fullBoxVariant || document.querySelector('#variant-options input[checked]');
      
      if (targetVariant) {
        this.updateVariantSelection(targetVariant.value);
      }
    }

    /**
     * Monitor URL changes for GemPages variant switching
     */
    monitorUrlChanges() {
      let currentUrl = window.location.href;
      
      // Check for URL changes every 100ms
      setInterval(() => {
        if (window.location.href !== currentUrl) {
          currentUrl = window.location.href;
          
          // URL changed, handle new variant
          setTimeout(() => {
            this.handleUrlVariant();
            this.updateCalculatorDisplay();
          }, 50);
        }
      }, 100);
      
      // Also listen for popstate (back/forward navigation)
      window.addEventListener('popstate', () => {
        setTimeout(() => {
          this.handleUrlVariant();
          this.updateCalculatorDisplay();
        }, 50);
      });
    }

    /**
     * Update variant attributes with current variant data
     */
    updateVariantAttributes() {
      const checkedRadio = document.querySelector('#variant-options input[type="radio"]:checked');
      if (!checkedRadio) return;
      
      const variantAttributes = document.querySelector('.variant_attributes');
      if (!variantAttributes) return;
      
      // Update attributes with current variant data
      variantAttributes.setAttribute('data-sqft', checkedRadio.getAttribute('data-sqft') || '');
      variantAttributes.setAttribute('data-original-price', checkedRadio.getAttribute('data-original-price') || '');
      variantAttributes.setAttribute('data-discounted-price', checkedRadio.getAttribute('data-discounted-price') || '');
      variantAttributes.setAttribute('data-fullbox-price', checkedRadio.getAttribute('data-fullbox-price') || '');
      variantAttributes.setAttribute('data-sample-price', checkedRadio.getAttribute('data-sample-price') || '');
      variantAttributes.setAttribute('data-sample-type', checkedRadio.getAttribute('data-sample-type') || '');
      variantAttributes.setAttribute('data-sample-max-qty', checkedRadio.getAttribute('data-sample-max-qty') || '');
      variantAttributes.setAttribute('data-available', checkedRadio.getAttribute('data-available') || 'false');
      variantAttributes.setAttribute('data-inventory-quantity', checkedRadio.getAttribute('data-inventory-quantity') || '0');
      variantAttributes.setAttribute('data-available', checkedRadio.getAttribute('data-available') || false);
      variantAttributes.setAttribute('data-stock-notice', checkedRadio.getAttribute('data-stock-notice') || '');
    }

    /**
     * Update calculator display based on current variant and availability
     */
    updateCalculatorDisplay() {
      // Update variant attributes first
      this.updateVariantAttributes();
      
      const currentVariant = this.getCurrentVariantTitle();
      const hasAvailableFullBox = this.hasAvailableFullBoxVariants();

      
      // If no available full box variants, always show sample calculator
      if (!hasAvailableFullBox) {
        this.showSampleCalculator();
        return;
      }
      
      // If full box variants are available, check variant type
      if (this.isTypeSample(currentVariant)) {
        this.showSampleCalculator();
      } else {
        // Default to fullbox calculator
        this.showFullBoxCalculator();
      }
    }

    /**
     * Get current variant title from checked radio
     */
    getCurrentVariantTitle() {
      const checkedRadio = document.querySelector('#variant-options input[type="radio"]:checked');
      if (checkedRadio) {
        return checkedRadio.getAttribute('data-title') || '';
      }
      
      return this.config.defaultVariant;
    }

    /**
     * Show sample calculator and hide fullbox calculator
     */
    showSampleCalculator() {
      if (window.fullBoxCalculator) {
        window.fullBoxCalculator.hide();
      }
      
      if (window.simpleSampleCalculator) {
        window.simpleSampleCalculator.show();
        window.simpleSampleCalculator.updateConfiguration();
      }
    }

    /**
     * Show fullbox calculator and hide sample calculator
     */
    showFullBoxCalculator() {
      if (window.simpleSampleCalculator) {
        window.simpleSampleCalculator.hide();
      }
      
      if (window.fullBoxCalculator) {
        window.fullBoxCalculator.show();
        window.fullBoxCalculator.updateConfiguration();

        // Force a calculation to update the price display even if input is empty
        window.fullBoxCalculator.calculate();
      }
    }
    
    /**
     * Check if variant is a sample type
     */
    isTypeSample(variantTitle) {
      if (!variantTitle) return false;
      
      // Check for various sample patterns
      const samplePatterns = [
        /\bSample\b/i,           // "Sample" word
        /\bsamples\b/i,          // "samples" word  
        /^7\.5$/i,               // Just "7.5"
        /^7\.5"/i,               // "7.5""
        /^15$/i,                 // Just "15"
        /^15"/i,                 // "15""
        /^3\s*-\s*15$/i,         // "3 - 15" format
        /^3.*15$/i,              // "3...15" variations
        /7\.5.*sample/i,         // "7.5 sample" variations
        /15.*sample/i,           // "15 sample" variations
        /sample.*7\.5/i,         // "sample 7.5" variations
        /sample.*15/i,           // "sample 15" variations
        /plank.*sample/i,        // "plank sample" variations
        /\b15\b/i,               // Any "15" word boundary
        /\b7\.5\b/i              // Any "7.5" word boundary
      ];
      
      return samplePatterns.some(pattern => pattern.test(variantTitle));
    }

    /**
     * Check if variant is a box type
     */
    isTypeBox(variantTitle) {
      if (!variantTitle) return false;
      return /\bBox\b/i.test(variantTitle);
    }

    /**
     * Get current variant ID from URL or default
     */
    getCurrentVariantId() {
      const urlParams = new URLSearchParams(window.location.search);
      const variantIdFromUrl = urlParams.get('variant');
      
      if (variantIdFromUrl) {
        return variantIdFromUrl;
      }
      
      const checkedRadio = document.querySelector('#variant-options input[type="radio"]:checked');
      if (checkedRadio) {
        return checkedRadio.value;
      }
      
      return this.config.defaultVariantId;
    }

    /**
     * Check if any full box variants are available
     */
    hasAvailableFullBoxVariants() {
      // Check data attribute from Liquid template
      const variantAttributes = document.querySelector('.variant_attributes');
      if (variantAttributes) {
        const hasAvailableFullBox = variantAttributes.getAttribute('data-has-available-fullbox');
        return hasAvailableFullBox === 'true';
      }
      
      // Fallback: check variant options directly
      let hasAvailableFullBox = false;
      this.elements.variantRadios.forEach(radio => {
        const title = radio.getAttribute('data-title') || '';
        const available = radio.getAttribute('data-available');
        
        if (title.toLowerCase().includes('box') && available === 'true') {
          hasAvailableFullBox = true;
        }
      });
      
      return hasAvailableFullBox;
    }
  }

  // Wait for calculator instances to be available
  function initializeWhenReady() {
    if (window.simpleSampleCalculator && window.fullBoxCalculator) {
      const calculator = new ProductCalculatorController();
      window.productCalculatorController = calculator;
    } else {
      setTimeout(initializeWhenReady, 100);
    }
  }
  
  initializeWhenReady();
  
  // Add debug functions
  window.debugCalculatorUrl = () => {
    const calculator = window.productCalculatorController;
    if (!calculator) return 'Controller not initialized';
    
    const urlParams = new URLSearchParams(window.location.search);
    const variantId = urlParams.get('variant');
    const currentVariant = calculator.getCurrentVariantTitle();
    
    return {
      url: window.location.href,
      variantParam: variantId,
      currentVariant: currentVariant,
      isSample: calculator.isTypeSample(currentVariant),
      isBox: calculator.isTypeBox(currentVariant)
    };
  };
  
  window.debugShowSample = () => {
    if (window.simpleSampleCalculator) {
      window.simpleSampleCalculator.show();
      return 'Sample calculator shown';
    } else {
      return 'Sample calculator not found';
    }
  };
  
  window.debugShowFullbox = () => {
    if (window.fullBoxCalculator) {
      window.fullBoxCalculator.show();
      return 'Fullbox calculator shown';
    } else {
      return 'Fullbox calculator not found';
    }
  };
  
  window.debugVariants = () => {
    const variants = [];
    document.querySelectorAll('#variant-options input[type="radio"]').forEach(radio => {
      const title = radio.getAttribute('data-title');
      const isChecked = radio.checked;
      const controller = window.productCalculatorController;
      const isSample = controller ? controller.isTypeSample(title) : 'Controller not ready';
      
      variants.push({
        id: radio.value,
        title: title,
        checked: isChecked,
        isSample: isSample
      });
    });
    return variants;
  };
}); 